import React, {Fragment} from "react"

import {connect} from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import TextField from '@material-ui/core/TextField'
import ClearIcon from '@material-ui/icons/Clear'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import { I18n } from 'react-redux-i18n'

import ArticleInput from './autocompletes/ArticleInput'
import ArticleGroupInput from './autocompletes/ArticleGroupInput'
import SupplierInput from './autocompletes/SupplierInput'
import CustomerInput from './autocompletes/CustomerInput'
import PersonInput from './autocompletes/PersonInput'

import {
  addNormalSubject,
  deleteNormalSubject,
  updateNormalSubject,

  addPersonSubject,
  deletePersonSubject,
  updatePersonSubject
} from '../../../actions/updateAppointmentActions'

const styles = theme => ({
  form: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  container: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  formControl: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 'calc(100% - ' + theme.spacing.unit*2 + 'px)',
  },
  button: {
    textAlign: 'center'
  },
  hr: {
    width: '100%',
    height: '1px',
    border: '0',
    backgroundColor: 'rgba(0,0,0,0.12)'
  },
  errorLabelContainer:{
    margin: theme.spacing.unit,
  },
  errorLabel:{
    color: theme.palette.error.main,
  },
})

class Subjects extends React.Component {

  handleAddNormalSubject = (e) => {
    this.props.dispatch(addNormalSubject())
  }

  handleDeleteNormalSubject = (idx) => {
    this.props.dispatch(deleteNormalSubject(idx))
  }

  handleNormalSubjectsChange = (value, idx) => {
    const newSubject = {
      type: value,
      value: ''
    }

    this.props.dispatch(updateNormalSubject(idx, newSubject))
  }

  handleNormalSubjectsValueChange = (value, idx) => {
    const newSubject = {
      ...this.props.updateAppointment.normalSubjects[idx],
      value: value
    }


    this.props.dispatch(updateNormalSubject(idx, newSubject))
  }

  handleAddPersonSubject = (e) => {
    this.props.dispatch(addPersonSubject())
  }

  handleDeletePersonSubject = (idx) => {
    this.props.dispatch(deletePersonSubject(idx))
  }

  handlePersonSubjectsChange = (value, idx) => {
    const newSubject = {
      type: value,
      value: ''
    }

    this.props.dispatch(updatePersonSubject(idx, newSubject))
  }

  handlePersonSubjectsValueChange = (value, idx) => {
    const newSubject = {
      ...this.props.updateAppointment.personSubjects[idx],
      value: value
    }

    this.props.dispatch(updatePersonSubject(idx, newSubject))
  }

  render() {
    return (
      <Fragment>
        <NormalSubjects
          updateAppointment={this.props.updateAppointment}
          handleAddNormalSubject={this.handleAddNormalSubject}
          handleDeleteNormalSubject={this.handleDeleteNormalSubject}
          handleNormalSubjectsChange={this.handleNormalSubjectsChange}
          handleNormalSubjectsValueChange={this.handleNormalSubjectsValueChange}
          classes={this.props.classes} />
        <PersonSubjects
          updateAppointment={this.props.updateAppointment}
          handleAddPersonSubject={this.handleAddPersonSubject}
          handleDeletePersonSubject={this.handleDeletePersonSubject}
          handlePersonSubjectsChange={this.handlePersonSubjectsChange}
          handlePersonSubjectsValueChange={this.handlePersonSubjectsValueChange}
          classes={this.props.classes} />
      </Fragment>
    )
  }
}

function NormalSubjects(props){
  const { classes } = props

  const subjects = props.updateAppointment.normalSubjects.map((normalSubject, idx) =>
    <NormalSubjectSelect
      key={idx}
      idx={idx}
      normalSubject={normalSubject}
      updateAppointment={props.updateAppointment}
      handleDeleteNormalSubject={props.handleDeleteNormalSubject}
      handleNormalSubjectsChange={props.handleNormalSubjectsChange}
      handleNormalSubjectsValueChange={props.handleNormalSubjectsValueChange}
      classes={classes} />
  )

  return (
    <Fragment>
      {subjects}
      <Grid container className={classes.container}>
        <Grid item xs={12} className={classes.button}>
          <Button variant="contained" color="secondary" onClick={props.handleAddNormalSubject}>{I18n.t('editAppointment.add_subject')}</Button>
        </Grid>
      </Grid>
      <hr className={classes.hr}/>
    </Fragment>
  )
}

function NormalSubjectSelect(props){
  const { classes } = props

  let error = false
  let errorMessage = ''

  if(props.updateAppointment.error != null ){
    if(props.updateAppointment.error.errors[`normalSubjects.${props.idx}.value`] != null){
      error = true
      errorMessage = props.updateAppointment.error.errors[`normalSubjects.${props.idx}.value`][0]
    }
  }

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} className={classes.errorLabelContainer}>
        <label className={classes.errorLabel}>
          {error ?
            (
              errorMessage
            ) : (
              null
            )
          }
        </label>
      </Grid>

      <Grid item xs={4}>
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="age-simple">{I18n.t('editAppointment.subject')}</InputLabel>
          <Select
            value={props.normalSubject.type}
            onChange={(e) => props.handleNormalSubjectsChange(e.target.value, props.idx)}
            inputProps={{
              name: 'subject'
            }}
          >
            <MenuItem value={1}>Vrij</MenuItem>
            <MenuItem value={2}>Artikel</MenuItem>
            <MenuItem value={3}>Artikelgroep</MenuItem>
            <MenuItem value={4}>Steekwoord</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={6} sm={7}>
        {(function() {
          switch(props.normalSubject.type) {
            case 1:
            case 4:
              return (
                <TextField
                        onChange={(e) => props.handleNormalSubjectsValueChange(e.target.value, props.idx)}
                        value={props.normalSubject.value}
                        required
                        className={classes.formControl}
                        margin="normal" />
              )
            case 2:
              return (
                <ArticleInput
                  value={props.normalSubject.value}
                  idx={props.idx}
                  handleNormalSubjectsValueChange={props.handleNormalSubjectsValueChange} />
              )
            case 3:
              return (
                <ArticleGroupInput
                  value={props.normalSubject.value}
                  idx={props.idx}
                  handleNormalSubjectsValueChange={props.handleNormalSubjectsValueChange} />
              )
            default:
              return null
          }
        })()}
      </Grid>

      <Grid item xs={2} sm={1} style={{textAlign: 'right'}}>
        <IconButton onClick={() => props.handleDeleteNormalSubject(props.idx)} className={classes.button} component="span">
          <ClearIcon />
        </IconButton>
      </Grid>
    </Grid>
  )
}

function PersonSubjects(props){
  const { classes } = props

  const subjects = props.updateAppointment.personSubjects.map((personSubject, idx) =>
    <PersonSubjectSelect
      key={idx}
      idx={idx}
      personSubject={personSubject}
      updateAppointment={props.updateAppointment}
      handleDeletePersonSubject={props.handleDeletePersonSubject}
      handlePersonSubjectsChange={props.handlePersonSubjectsChange}
      handlePersonSubjectsValueChange={props.handlePersonSubjectsValueChange}
      classes={classes} />
  )

  return (
    <Fragment>
      {subjects}
      <Grid container className={classes.container}>
        <Grid item xs={12} className={classes.button}>
          <Button variant="contained" color="secondary" onClick={props.handleAddPersonSubject}>{I18n.t('editAppointment.add_person')}</Button>
        </Grid>
      </Grid>
    </Fragment>
  )
}

function PersonSubjectSelect(props){
    const { classes } = props

    let error = false
    let errorMessage = ''

    if(props.updateAppointment.error != null ){
      if(props.updateAppointment.error.errors[`normalSubjects.${props.idx}.value`] != null){
        error = true
        errorMessage = props.updateAppointment.error.errors[`normalSubjects.${props.idx}.value`][0]
      }
    }

    return (
      <Grid container className={classes.container}>
        <Grid item xs={12} className={classes.errorLabelContainer}>
          <label className={classes.errorLabel}>
            {error ?
              (
                errorMessage
              ) : (
                null
              )
            }
          </label>
        </Grid>

        <Grid item xs={4}>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="age-simple">{I18n.t('editAppointment.person')}</InputLabel>
            <Select
              value={props.personSubject.type}
              onChange={(e) => props.handlePersonSubjectsChange(e.target.value, props.idx)}
              inputProps={{
                name: 'subject'
              }}
            >
              <MenuItem value={3}>{I18n.t('editAppointment.supplier')}</MenuItem>
              <MenuItem value={2}>{I18n.t('editAppointment.customer')}</MenuItem>
              <MenuItem value={1}>{I18n.t('editAppointment.person')}</MenuItem>
              <MenuItem value={4}>{I18n.t('editAppointment.free')}</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={6} sm={7}>
          {(function() {
            switch(props.personSubject.type) {
              case 3:
                return (
                  <SupplierInput
                    value={props.personSubject.value}
                    idx={props.idx}
                    handlePersonSubjectsValueChange={props.handlePersonSubjectsValueChange} />
                )
              case 2:
                return (
                  <CustomerInput
                    value={props.personSubject.value}
                    idx={props.idx}
                    handlePersonSubjectsValueChange={props.handlePersonSubjectsValueChange} />
                )
              case 1:
                return (
                  <PersonInput
                    value={props.personSubject.value}
                    idx={props.idx}
                    handlePersonSubjectsValueChange={props.handlePersonSubjectsValueChange} />
                )
                case 4:
                  return (
                    <TextField
                      onChange={(e) => props.handlePersonSubjectsValueChange(e.target.value, props.idx)}
                      value={props.personSubject.value}
                      required
                      className={classes.formControl}
                      margin="normal" />
                  )
              default:
                return null
            }
          })()}
        </Grid>

        <Grid item xs={2} sm={1} style={{textAlign: 'right'}}>
          <IconButton onClick={() => props.handleDeletePersonSubject(props.idx)} className={classes.button} component="span">
            <ClearIcon />
          </IconButton>
        </Grid>
      </Grid>
    )
  }

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  updateAppointment: state.updateAppointment
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Subjects))



// WEBPACK FOOTER //
// ./src/js/components/pages/updateAppointment/Subjects.js